import HeaderVerde from '../HeaderVerde'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import Input from '../Input'
import Select from '../Select'
import React from 'react'

import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'

const Fiscalizadores = (props) => {
    const modo = useSelector((state) => state.addForm.modo)
    const [fiscais, setFiscais] = useState([])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    useEffect(() => {
        axios('/api/user/getFiscais')
            .then(res => setFiscais(res.data))
            .catch(error => alert(error.response.data))
    }, [])

    const modulo = props.modulo
    return (
        <>
            {modo === "view" ? (<></>) : (
                <Caixa>
                    <HeaderVerde texto="PROFISSIONAIS REALIZANDO A VISITA" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantidade" nome="fiscalizadores" modulo={modulo} index={0}
                            widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderFiscais()}
                    </div>

                    {/* <CheckContainer>
                        {RenderFiscais()}
                    </CheckContainer> */}
                </Caixa>
            )}
        </>
    )

    function RenderFiscais() {
        let campos = []
        if (condicional[modulo].length > 0) var array = condicional
        else var array = ficha
        var quantidade = array[modulo][0]["fiscalizadores"]
        if (array[modulo][0]["fiscalizadores"]) {
            for (let i = 0; i < quantidade; i++) {
                campos.push(
                    <Select label="Fiscal" nome="fiscais"
                        modulo={modulo} index={0} subModulo="fiscais" indexSub={i}
                        componentDisplay="inline-grid" widthDiv="30vw" widthMobile="80vw" marginR="3vw"
                        array={fiscais.map(el => el.nome)} />
                )
            }
        }
        return campos
    }
}

// function RenderFiscais() {
//     let options = []
//     fiscais.map(el => {
//         options.push(
//             <CheckBox texto={el.nome} grupo="fiscais" modulo={modulo} index={0}
//                 display="inline-grid" marginR="3vw" />
//         )
//     })
//     return options
// }
// }

export default Fiscalizadores